module.exports = __webpack_public_path__ + "img/SignUp.7364cd41.svg";